import { Route } from "react-router-dom";
import { routePaths } from "./helpers/routePaths";
import AttendeeEdit from "./pages/AttendeeEdit/AttendeeEdit";
import AttendeesOverview from "./pages/AttendeesOverview/AttendeesOverview";
import CreateEventFlow from "./pages/CreateEventFlow/CreateEventFlow";
import Dashboard from "./pages/Dashboard/Dashboard";
import EventInfo from "./pages/EventInfo/EventInfo";
import ActiveEvents from "./pages/ActiveEvents/ActiveEvents";
import UsersOverview from "./pages/UsersOverview/UsersOverview";
import ArchivedEvents from "./pages/ArchivedEvents/ArchivedEvents";
import EventSessions from "./pages/EventSessions/EventSessions";
import EventSessionEdit from "./pages/EventSessionEdit/EventSessionEdit";
import ReservationEdit from "./pages/ReservationEdit/ReservationEdit";
import ProfileView from "./pages/ProfileView/ProfileView";
import BadgeDesigner from "./pages/BadgeDesigner/BadgeDesigner";
import BadgeTemplatesList from "./pages/BadgeDesigner/BadgeTemplatesList";
import PasswordForgot from "./baseLayout/PasswordForgot";
import PasswordChange from "./baseLayout/PasswordChange";
import ReservationsView from "./pages/ReservationsView/ReservationsView";
import AccountsOverview from "./pages/AccountsOverview/AccountsOverview";
import APIDocsView, { apiType } from "./pages/APIDocsView/APIDocsView";
import BadgeSizesView from "./pages/BadgeSizesView/BadgeSizesView";
import BadgeSizeForm from "./pages/BadgeSizesView/BadgeSizeForm/BadgeSizeForm";
import VersionHistory from "./pages/VersionHistory/VersionHistory";
import AlertOverview from "./components/Alert/AlertOverview";
import MicroSite from "./components/Microsite/Microsite";

import Analytics from "./pages/Analytics/Analytics";
import ExhibitorEdit from "./pages/ExhibitorEdit/ExhibitorEdit";
import LeadRetrievalSettings from "./pages/LeadRetrievalSettings/LeadRetrievalSettings";
import ExhibitorList from "./pages/ExhibitorList/ExhibitorList";
import { LogProcess } from "./pages/LogProcess/LogProcess";
import AnalyticsDashboardPublic from "./baseLayout/AnalyticsDashboardPublic";
import KioskCenter from "./pages/KioskCenter/KioskCenter";
import LeadGuard from "./components/LeadGuard/LeadGuard";

export const customRoutes = [
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.DASHBOARD}`}
    element={<Dashboard />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.EDIT}`}
    element={<EventInfo />}
  />,
  <Route path={`/${routePaths.USERS}`} element={<UsersOverview />} />,
  <Route path={`/${routePaths.PROFILE}`} element={<ProfileView />} />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.ATTENDEES}`}
    element={<AttendeesOverview />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.ANALYTICS}`}
    element={<Analytics />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.SESSIONS}`}
    element={<EventSessions showFullSession={true} />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.SESSIONS}/:sessionId/${routePaths.EDIT}`}
    element={<EventSessionEdit />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.ATTENDEES}/new`}
    element={<AttendeeEdit />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.SESSIONS}/new`}
    element={<EventSessionEdit />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.SESSIONS}/:sessionId/${routePaths.RESERVATIONS}/new`}
    element={<ReservationEdit />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.SESSIONS}/:sessionId/${routePaths.RESERVATIONS}`}
    element={<ReservationsView activeTab="1" />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.SESSIONS}/:sessionId/${routePaths.SCANNED_IN_ATTENDEE}`}
    element={<ReservationsView activeTab="2" />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.SESSIONS}/:sessionId/${routePaths.RESERVATIONS}/:reservationId/${routePaths.EDIT}`}
    element={<ReservationEdit />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.ATTENDEES}/:attendeeId/${routePaths.EDIT}`}
    element={<AttendeeEdit />}
  />,
  <Route
    path={`/${routePaths.BADGE_SIZES}/:formatId/${routePaths.EDIT}`}
    element={<BadgeSizeForm />}
  />,
  <Route path={`/${routePaths.BADGE_SIZES}/new`} element={<BadgeSizeForm />} />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.BADGE_TEMPLATES}`}
    element={<BadgeTemplatesList />}
  />,
  <Route path={`/${routePaths.BADGE_SIZES}`} element={<BadgeSizesView />} />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.BADGE_DESIGNER}`}
    element={<BadgeDesigner />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.BADGE_TEMPLATES}/:templateId`}
    element={<BadgeDesigner />}
  />,

  // FdLead Migration ROLLBACK: LeadGuard shows PortalV2Only when CAN_MANAGE_LEADS has no roles. Switch it in roles.ts, not here.
  <Route path={`/${routePaths.EVENTS}/:eventId/${routePaths.EXHIBITOR}`} element={<LeadGuard><ExhibitorList /></LeadGuard>} />,
  <Route path={`/${routePaths.EVENTS}/:eventId/${routePaths.EXHIBITOR}/:exhibitorId/${routePaths.EDIT}`} element={<LeadGuard><ExhibitorEdit /></LeadGuard>} />,
  <Route path={`/${routePaths.EVENTS}/:eventId/${routePaths.EXHIBITOR}/new`} element={<LeadGuard><ExhibitorEdit /></LeadGuard>} />,
  <Route path={`/${routePaths.EVENTS}/:eventId/${routePaths.LEAD_RETRIEVAL_SETTINGS}`} element={<LeadGuard><LeadRetrievalSettings /></LeadGuard>} />,

  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.LOG_PROCESS}`}
    element={<LogProcess />}
  />,
  <Route path={`/${routePaths.CREDITS}`} element={<>Credits</>} />,
  <Route path={`/${routePaths.ZENDESK}`} element={<>Zendesk</>} />,
  <Route path={`/${routePaths.HINTS}`} element={<>Tips and hints</>} />,
  <Route path={`/${routePaths.ACCOUNTS}`} element={<AccountsOverview />} />,
  <Route
    path={`/${routePaths.DEVELOPER_API_DOCS}`}
    element={<APIDocsView type={apiType.DEVELOPER} />}
  />,
  <Route
    path={`/${routePaths.SYSADMIN_API_DOCS}`}
    element={<APIDocsView type={apiType.SYSADMIN} />}
  />,
  <Route path={`/${routePaths.ACTIVE_EVENTS}`} element={<ActiveEvents />} />,
  <Route
    path={`/${routePaths.ARCHIVED_EVENTS}`}
    element={<ArchivedEvents />}
  />,
  // <Route
  //   path={`/list`}
  //   element={<UniversalList list={[]} />}
  // />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.ALERT}`}
    element={<AlertOverview />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.MICROSITE}`}
    element={<MicroSite />}
  />,
  <Route
    path={`/${routePaths.EVENTS}/:eventId/${routePaths.KIOSK_CENTER}`}
    element={<KioskCenter />}
  />,
];

export const customRoutesNoLayout = [
  <Route
    path={`/${routePaths.PASSWORD_FORGOT}`}
    element={<PasswordForgot />}
  />,
  <Route
    path={`/${routePaths.PASSWORD_CHANGE}`}
    element={<PasswordChange />}
  />,
  <Route path={`/${routePaths.NEW_EVENT}`} element={<CreateEventFlow />} />,
  <Route
    path={`/${routePaths.VERSION_HISTORY}`}
    element={<VersionHistory />}
  />,
  <Route
    path={`/${routePaths.ANALYTICS_DASHBOARD}/:dashboardPublicToken`}
    element={<AnalyticsDashboardPublic />}
  />,
];
